import isBlank from "@sedan-utils/is-blank";
import { FuncResponse, FuncResponseType, FunctionBase } from "../../storyV2/function/FunctionBase";
import { splitTextFunc } from "../../util/RegUtil";
import { FunctionUtil } from "../../storyV2/function/FunctionUtil";
export class SplitOutputFunction extends FunctionBase {
    async run(input, identityInfo) {
        /// 本地逻辑拆分文字为数组
        const splitResult = splitTextFunc(input, FunctionUtil.createAbortUuid(identityInfo));
        /// 如果本地拆分结果数量小于等于1，则调用api拆分
        if (splitResult.length <= 1) {
            const res = await this.splitOutput(input);
            return new FuncResponse(FuncResponseType.STRING_GROUP, res);
        }
        /// 本地拆分数量没问题的话，则返回本地拆分的结果
        return new FuncResponse(FuncResponseType.STRING_GROUP, splitResult);
    }
    async splitOutput(input, uuid) {
        const res = await this.brainClient.openAi.splitOutput(input, uuid);
        let results = [];
        const text = res?.data?.choices?.[0]?.text || res?.data?.choices?.[0]?.message?.content || "";
        if (typeof text === "string") {
            results = text.split("\n").filter(x => !isBlank(x));
        }
        return results;
    }
}
